import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";

const ResultsDropdowns = ({ attrDropBtn, dropBtnContent, dropItem }) => {
  const renderMenuItems = (items) =>
    items.map((item) =>
      item.children ? (
        <Menu.SubMenu key={item.key} title={item.label}>
          {renderMenuItems(item.children)}
        </Menu.SubMenu>
      ) : (
        <Menu.Item key={item.key} onClick={item.onClick}>
          {item.label}
        </Menu.Item>
      )
    );

  const menu = <Menu>{renderMenuItems(dropItem)}</Menu>;

  return (
    <Dropdown overlay={menu} trigger={["hover"]} placement="bottomLeft">
      <Button {...attrDropBtn}>
        {dropBtnContent} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default ResultsDropdowns;